import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import HotTicker from './components/HotTicker';
import FeaturedSection from './components/FeaturedSection';
import TopicsSection from './components/TopicsSection';
import TimelineSection from './components/TimelineSection';
import RankingSection from './components/RankingSection';
import EntryCTA from './components/EntryCTA';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <HotTicker />
        <FeaturedSection />
        <TopicsSection />
        <TimelineSection />
        <RankingSection />
        <EntryCTA />
      </main>
      <SiteFooter />
    </div>
  );
}